'use strict';(function () {

  function validateMatchFields() {
    var matchElements = document.querySelectorAll('[data-match-input-id]');
    var matchGroups = {};var _loop = function _loop(
    i) {
      var element = matchElements[i];
      var matchId = element.getAttribute('data-match-input-id');
      if (!matchGroups[matchId]) {
        matchGroups[matchId] = [];
      }
      matchGroups[matchId].push(element);

      element.addEventListener('change', function (event) {
        var validationGroup = matchGroups[matchId];
        if (validationGroup.length !== 2) return;

        if (validationGroup[0].value === validationGroup[1].value) {
          validationGroup[1].setCustomValidity('');
        } else {
          validationGroup[1].setCustomValidity('Fields do not match');
          validationGroup[1].reportValidity();
        }
      });};for (var i = 0; i < matchElements.length; i++) {_loop(i);
    }
  }
  validateMatchFields();
})();